import styled, { css } from 'styled-components';
import { resetInput, align } from 'styled-manila';
import { getColor } from 'core/utils/Styles';

export const Wrapper = styled.div`
	font-size: 14px;
	position: relative;
	margin-top: 20px;
	background-color: ${getColor('white')};
	transition: 0.3s;
	border-radius: 4px;

	/* stylelint-disable */
	${props => props.invalid && css`
		margin-bottom: 70px;
	`};
	/* stylelint-enable */
`;

export const Label = styled.label`
	${align('vertical')};
	line-height: 10px;
	left: 15px;
	color: ${getColor('gray8')};
	transition: 0.3s ease-in-out;
	font-weight: 400;
	margin: 0;
`;

export const Input = styled.input`
	${resetInput}
	width: 100%;
	height: 40px;
	outline: none;
	margin: 0;
	padding: 10px 1em;
	resize: none;
	border: 1px solid ${getColor('gray3')};
	border-radius: 4px;

	&:focus {
		border: 2px solid ${getColor('primaryBrand')};

		/* stylelint-disable */
		& + ${Label} {
			color: ${getColor('darkTeal')};
		}
		/* stylelint-enable */
	}

	/* stylelint-disable */
	&[required]:valid + ${Label},
	&:focus + ${Label} {
		transform: scale(0.9, 0.9) translateY(-360%);
		transition: 0.2s ease-in-out;
		left: 0;
	}
	/* stylelint-enable */

	&:required {
		box-shadow: none;
	}

	/* stylelint-disable */
	${props => props.invalid && css`
		border-color: ${getColor('salmon')};

		/* stylelint-disable */
		& + ${Label} {
			color: ${getColor('salmon')};
			transform: scale(0.9, 0.9) translateY(-360%);
			transition: 0.2s ease-in-out;
			left: 0;
		}
		/* stylelint-enable */
	`}
	/* stylelint-enable */
`;

export const ErrorMsg = styled.span`
	position: absolute;
	left: 4px;
	top: 100%;
	display: block;
	color: ${getColor('salmon')};
	margin: 0;
	font-size: 14px;
	font-weight: 600;
	background-color: ${getColor('bridesmaid')};
	height: 100%;
	padding-top: 10px;
	padding-bottom: 10px;
	text-align: center;
	border-radius: ${props => props.show ? '0 0 4px 4px' : '4px'};
	width: calc(100% - 8px);
	transition: 0.3s;
	transform: ${props => props.show ? 'translateY(0)': 'translateY(-100%)'};
	z-index: ${props => props.show ? '0' : '-1'};
`;
